// src/components/ProtectedRoute.js
// Wraps routes that require sign-in. Redirects to /login when not authenticated.

import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import VolugraphLoadingScreen from './VolugraphLoadingScreen';

function ProtectedRoute() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <VolugraphLoadingScreen />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.emailCodeVerified === false) {
    const returnPath = `${location.pathname}${location.search || ''}`;
    const to = `/login?mode=signup&verify=1&returnUrl=${encodeURIComponent(returnPath)}`;
    return <Navigate to={to} replace />;
  }

  return <Outlet />;
}

export default ProtectedRoute;
